export default __webpack_public_path__ + "static/media/image.soar-aviation-group-pvt-ltd-.0956f7d6.png";